export default __webpack_public_path__ + "static/new7-03-8c44d145847b38b28dd1dd9df816fbbb.jpg";